import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ShapeStarhalfFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M15.88 17.3001L12.02 14.5801V5.40012L13.58 9.78012L18.26 9.94012L14.52 12.7601L15.88 17.3001ZM22.44 8.68012L14.74 8.30012L12.02 1.12012L9.27996 8.30012L1.57996 8.68012L7.59996 13.4801L5.55996 20.9601L12.02 16.6801L18.46 20.9601L16.42 13.4801L22.44 8.68012Z"
      />
    </SvgIcon>
  );
});
